import React, { forwardRef } from "react"
import type { LucideProps } from "lucide-react"

export const TrendingUpIconActive = forwardRef<SVGSVGElement, LucideProps>(
  (
    {
      size = 24,
      color = "currentColor",
      strokeWidth = 1.8,
      className,
      ...props
    },
    ref,
  ) => {
    return (
      <svg
        ref={ref}
        xmlns="http://www.w3.org/2000/svg"
        width={size}
        height={size}
        viewBox="0 0 24 24"
        fill="none"
        stroke={color}
        strokeWidth={strokeWidth}
        strokeLinecap="round"
        strokeLinejoin="round"
        className={className}
        {...props}
      >
        <polyline points="22 7 13.5 15.5 8.5 10.5 2 17" />
        <polyline points="16 7 22 7 22 13" />
        <circle cx="13.5" cy="15.5" r="2" fill="currentColor" />
        <circle cx="8.5" cy="10.5" r="2" fill="currentColor" />
      </svg>
    )
  },
)

TrendingUpIconActive.displayName = "TrendingUpIconActive"
